import React, { Component } from 'react'

class checkAppVersion extends Component {
  constructor(props) {
    super(props)
    this.state = {};
    this.versionRef = React.createRef();
    this.timer = React.createRef();
  }
  componentDidMount = () => {
    this.executeOnTimer()
    this.timer = setInterval(() => { this.executeOnTimer() }, 30 * 1000);
  }
  componentWillUnmount = () => {
    clearInterval(this.timer)
  }
  executeOnTimer = async () => {
    try {
      let onlineVersion = await this.props.getVersion()
      if (this.versionRef.current) {
        if (this.versionRef.current && (this.versionRef.current !== onlineVersion)) {
          window.location.reload(true);
        }
      } else {
        this.versionRef.current = onlineVersion;
      }
    } catch(e) {
      console.log('Error');
    }
  }
  render() {
    return (null)
  }
}

export default checkAppVersion;
